import logIt from "../../../logIt";

/**
 * Utility function to convert pixels to rem
 * for e.g 363px will convert in 22.688rem
 */
const ConvertPixelToRem = (pixel) => {
    if (pixel) {
        const unit = pixel.split('').splice(-2).join('');
        const pixelValue = parseInt(pixel.substring(0, pixel.indexOf(unit)));
        if (unit === 'px' && pixelValue > 0) {
            // only 'px' unit accepted, if other unit or incorrect data specified, it would return as it is.
            const remValue = `${(pixelValue / 16).toFixed(3)}rem`;
            return remValue;
        }
    }
    logIt(`Incorrect pixel value defined: ${pixel}`);
    return pixel;
};
export default ConvertPixelToRem;
